import { SimpleInput, SimpleInputProps } from '@aloft/toolkit-sui';

import { forwardRef } from 'react';

type AreaInputProps = Pick<
  SimpleInputProps,
  'onChange' | 'onBlur' | 'name' | 'label' | 'required' | 'id' | 'value' | 'errorMessage'
>;

export const AreaInput = forwardRef<HTMLInputElement, AreaInputProps>((props, ref) => (
  <SimpleInput ref={ref} size="sm" type="number" rightAddon="sf" useSeparator {...props} />
));
